import React, { useEffect, useRef } from 'react';

const Tooltip = ({ hoveredCell }) => {
    const tooltipRef = useRef(null);

    useEffect(() => {
        if (hoveredCell && hoveredCell.element && tooltipRef.current) {
            const cellRect = hoveredCell.element.getBoundingClientRect();
            const tooltip = tooltipRef.current;

            // Position above the cell
            const left = cellRect.left + (cellRect.width / 2) - (tooltip.offsetWidth / 2);
            const top = cellRect.top - tooltip.offsetHeight - 10;

            tooltip.style.left = `${Math.max(10, left)}px`;
            tooltip.style.top = `${Math.max(10, top)}px`;
        }
    }, [hoveredCell]);

    if (!hoveredCell) return null;

    return (
        <div
            ref={tooltipRef}
            style={{
                position: 'fixed',
                left: '0px', // Will be set by useEffect
                top: '0px',  // Will be set by useEffect
                background: 'rgba(0, 0, 0, 0.9)',
                color: 'white',
                padding: '8px 12px',
                borderRadius: '6px',
                fontSize: '12px',
                maxWidth: '300px',
                wordWrap: 'break-word',
                zIndex: 10000,
                boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                pointerEvents: 'none',
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
                visibility: hoveredCell.element ? 'visible' : 'hidden'
            }}
        >
            {hoveredCell.col === 'core_enrichment' ? (
                <>
                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>Core Enrichment Genes:</div>
                    <div>{hoveredCell.content.split('/').join(', ')}</div>
                </>
            ) : (
                <>
                    <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>{hoveredCell.col}:</div>
                    <div>{hoveredCell.content}</div>
                </>
            )}
        </div>
    );
};

export default Tooltip; 